import { gql } from '@apollo/client';
const REMOVE_COMPONENT = gql `
  mutation RemoveComponent($componentId: ID!) {
    removeComponent(componentId: $componentId) {
      removed
    }
  }
`;
export default REMOVE_COMPONENT;
